function clean(value: string | undefined): string {
  return value?.trim() ?? "";
}

function joinUrl(base: string, path: string): string {
  if (!base) return "";
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

const parent =
  clean(import.meta.env.VITE_PARENT_ORIGIN).replace(/\/$/, "") ||
  "https://azurehomeloans.com.au";

export const compliance = {
  brand: "Azure Home Loans",
  representative: "Bishnu Adhikari",
  broker: clean(import.meta.env.VITE_BROKER_NAME) || "Azure Home Loans",
  abn: clean(import.meta.env.VITE_ABN) || "77 676 207 131",
  crn: clean(import.meta.env.VITE_CRN) || "538895",
  acl: clean(import.meta.env.VITE_ACL) || "390261",
  licensee: clean(import.meta.env.VITE_LICENSEE) || "ACL 390261",
  aggregator: clean(import.meta.env.VITE_AGGREGATOR) || "Yellow Brick Road",
  afca: clean(import.meta.env.VITE_AFCA),
  phone: clean(import.meta.env.VITE_PHONE) || "0400 77 77 55",
  email: clean(import.meta.env.VITE_EMAIL) || "bishnu@azurehomeloans.com.au",
  parent,
  privacyUrl:
    clean(import.meta.env.VITE_PRIVACY_URL) || "https://azurehomeloans.com.au/privacy",
  creditGuideUrl:
    clean(import.meta.env.VITE_CREDIT_GUIDE_URL) || joinUrl(parent, "/privacy"),
  complaintsUrl: joinUrl(parent, "/contact"),
  configured: true,
};

export function licenceLine(): string {
  return `Credit assistance is provided by ${compliance.representative}, mortgage broker — ACR ${compliance.crn}, authorised under ACL ${compliance.acl}. Legal/trading name: ${compliance.brand}. Aggregator: ${compliance.aggregator}. ABN ${compliance.abn}.`;
}

export function phoneHref(): string {
  const digits = compliance.phone.replace(/\s/g, "");
  if (!digits) return "";
  return digits.startsWith("+") ? `tel:${digits}` : `tel:+61${digits.replace(/^0/, "")}`;
}

export function whatsappHref(): string {
  const digits = compliance.phone.replace(/\D/g, "");
  if (!digits) return "";
  const intl = digits.startsWith("0") ? `61${digits.slice(1)}` : digits;
  return `https://wa.me/${intl}`;
}
